<template>
  <div class="list-body" :class="{'extract-style': showExtract}" v-show="showMain">
    <div class="list--body-extract" v-if="showExtract">
      <div class="form-list">
        <div class="form-label">
          <label>{{$t('core.extract_code')}}</label>
        </div>
        <div class="form-input">
          <div class="form-unit" :class="{'is-error':extractErrorCode}">
            <input class="tc-15-input-text m" v-model.trim="extract" style="width:250px;" @keyup.enter="getShareConfig">
            <p class="form-input-help">{{ translateExtractErrorCode }}</p>
          </div>
        </div>
        <qc-button class="ml-10" @click="getShareConfig">{{$t('cos.extract')}}</qc-button>
      </div>
    </div>
    <div class="list-body-container" v-else>

      <!-- 操作栏 -->
      <div class="tc-action-grid">
        <div class="justify-grid">
          <div class="col">
            <template v-if="!disabledBtn.upload">
              <qc-button v-if="crumbs.length > 1" :disabled="disabledBtn.upload || searchBarExist" type="default"
                size="short" @click="onEventAction({ action : 'uploadFiles'})">{{$t('core.upload')}}
              </qc-button>
              <qc-button v-if="crumbs.length > 1" :disabled="disabledBtn.upload || searchBarExist" type="weak"
                size="short" @click="onEventAction({ action : 'createFolder'})">{{$t('core.create_folder')}}
              </qc-button>
            </template>
          </div>

          <div class="col">
            <div class="tc-15-search tc-15-multi-search">
              <div class="search-input-wrap">
                <input class="tc-15-search-words" type="text" ref="searchInput" v-model="keyword"
                  @keyup.enter="onSearch" :placeholder="$t('cos.prefix_search')">
                <a v-if="keyword" href="#" role="button" class="btn-rm-txt" :title="$t('core.clear')"
                  @click="closeSearch">{{$t('core.clear')}}</a>
                <button class="tc-15-btn weak m search" @click="onSearch"></button>
              </div>
            </div>

            <button type="button" class="tc-15-btn weak m refresh" @click="onRefresh">{{$t('core.refresh')}}</button>
          </div>
        </div>
      </div>

      <!-- 面包屑导航 -->
      <div class="tc-action-grid pb-0">
        <div class="divider m-0" style="width:100%;height: 1px;"></div>
        <div class="justify-grid">

          <div class="col">
            <breadcrumb ref="breadcrumbs" v-model="crumbs"></breadcrumb>
          </div>
        </div>
      </div>

      <div class="tc-panel panel-Page">

        <div class="tc-action-grid search-bar" v-if="isSearching || isSearchDone">
          <div class="justify-grid">
            <template>
              <div class="col">
                <span class="search-text">{{$t('core.search_result[0]',{result:list.length})}}</span>
                <qc-icon v-if="isSearching" :type="'loading'"></qc-icon>
              </div>
              <div class="col">
                <a v-if="isSearched && isSearching" href="javascript:;" class="cancel-search"
                  @click="cancelSearch">{{$t('core.cancel')}}</a>
                <a v-else href="javascript:;" class="cancel-search" @click="closeSearch">{{$t('core.close')}}</a>
              </div>
            </template>
          </div>
        </div>
        <file-table ref="table" v-model="list" :loading="loading" :search-status="{isSearched,isSearching,isSearchDone}"
          :hasAuthority="hasAuthority" :isExpired="isExpired" :tableShowErr="tableShowErr" :pageSize="pageSize"
          :disabled-btn="disabledBtn" :currPage="currPage" @on-action="onEventAction">
          <template slot="footer">
            <pagination v-if="list.length > 100" :total-num="list.length" :page-size="pageSize" :curr-page="currPage"
              @change="changePage">
            </pagination>
            <span style="display: none;"></span>
          </template>
        </file-table>

      </div>
    </div>

    <advance-upload :show.sync="dialogShow.advanceUpload" :bucket-info="{ Bucket, Region, Prefix}" :open-maz="isMaz">
    </advance-upload>
    <delete-file :show.sync="dialogShow.delete" :list.sync="list" :selected-list="selectedList"
      :bucket-info="{Bucket,Region}" @fix-folder="fixFolder(Prefix)" @refresh="onRefresh">
    </delete-file>
    <create-folder ref="createFolder" :show.sync="dialogShow.create" :bucket-info="{ Bucket ,Region, Prefix }"
      @push-list="pushList($event.map(formatFileItem))">
    </create-folder>
    <!-- 各种操作失败表格展示 -->
    <failure-table :show.sync="dialogShow.failureTable"></failure-table>
    <!-- 区域选择器 -->
    <!-- <selector :layout="$store.layout"></selector> -->

    <!-- 下载使用 iframe -->
    <div v-show="0">
      <iframe id="downloadCosFile" src="" name="download" height="0" width="0"></iframe>
    </div>
  </div>
</template>

<script>
import pagination from 'components/common/pagination';
import breadcrumb from 'components/desktop/breadcrumb';
import fileTable from 'components/desktop/fileTable';
import advanceUpload from 'components/dialog/advanceUpload';
import deleteFile from 'components/dialog/deleteFile';
import createFolder from 'components/dialog/createFolder';
import failureTable from 'components/dialog/failureTable';
// import selector from 'components/common/selector';

// import $ from 'jquery';
import * as utils from 'tools/utils';
import { tips, dateToUnix, downloadUrl } from 'tools/utils';
import dao from '@/scripts/helper/dao';
import { setCredentials, cos } from 'helper/cos/index';
import storage, { StoreKey } from 'tools/storage';
import eventProxy from 'tools/eventProxy';
// import DragSelection from 'tools/DragSelection';

export default {
  components: {
    breadcrumb,
    fileTable,
    pagination,
    advanceUpload,
    deleteFile,
    createFolder,
    failureTable,
    // selector,
  },
  data() {
    return {
      showExtract: true,
      showMain: false,
      extractErrorCode: '',
      tableShowErr: null,

      loading: false,
      list: [],
      selectedList: [],

      id: '',
      sKeyToken: '',
      extract: '',
      shareInfo: {},

      Bucket: '',
      Region: '',
      Prefix: '',
      isMaz: false,
      marker: '',
      hasMore: false,

      crumbs: [],
      hasAuthority: true,
      isExpired: false,

      keyword: '',
      isSearching: false,
      isSearched: false,
      isSearchDone: false,

      // 分页器
      pageSize: 100,
      currPage: 1,

      dialogShow: {
        advanceUpload: false,
        delete: false,
        create: false,
        failureTable: false,
      },
      // dragSelection: {},
    };
  },
  computed: {
    disabledBtn() {
      const disabled = {
        upload: true,
        delete: true,
      };
      const { action } = this.shareInfo;
      if (!action) {
        return disabled;
      }

      if (action.includes('PutObject') || action.includes('*')) {
        disabled.upload = false;
        eventProxy.emit('allow-upload');
      }
      if (action.includes('DeleteObject') || action.includes('*')) {
        disabled.delete = false;
      }
      return disabled;
    },
    searchBarExist() {
      return this.isSearching || this.isSearchDone;
    },
    translateExtractErrorCode() {
      if (!this.extractErrorCode) return '';
      switch (this.extractErrorCode) {
        case 'NoSuchSid':
          return this.$t('error.current_share_link_does_not_exist');
        case 'ExpiredUrl':
          return this.$t('error.current_share_link_has_expired');
        case 'ErrorExtractCode':
          return this.$t('error.extract_code_error_please_re_enter');
        case 'GetAccessCodeWrong':
          return this.$t('error.decoding_failed_please_try_again');
        default:
          return this.$t('error.please_enter_6_digit_extract_code');
      }
    },
    // fileBody() {
    //   return this.$store.layout === 'grid'
    //     ? $('.grid-body')
    //     : $('.tc-15-table-fixed-body');
    // },
  },
  watch: {
    // 监听路由变化
    crumbs(val) {
      if (val.length === 0) return;
      if (val.length === 1) {
        this.initList();
        return;
      }
      this.resetSearch();
      const currCrumb = val[val.length - 1];
      this.Prefix = currCrumb.prefix;
      this.resetFolder();
    },
  },
  mounted() {
    this.handleUrlParams();
    eventProxy.on('upload-completed', this.onUploadFinish);
    // 拖选文件
    // eventProxy.on('command.selector-start', this.selectorStart);
    // eventProxy.on('command.selector-move', this.selectorMove);
    // eventProxy.on('command.selector-end', this.selectorEnd);
  },
  destroyed() {
    eventProxy.off('upload-completed', this.onUploadFinish);
    // this.dragSelection = null;
    // 拖选文件
    // eventProxy.off('command.selector-start', this.selectorStart);
    // eventProxy.off('command.selector-move', this.selectorMove);
    // eventProxy.off('command.selector-end', this.selectorEnd);
  },
  methods: {
    // 初始化面包屑导航
    initCrumbs() {
      this.$nextTick(() => {
        this.$refs.breadcrumbs.initCrumbs();
      });
    },
    showIndex() {
      tips.closeTips();
      this.showMain = true;
    },
    // 重置列表数据
    restData() {
      this.list = [];
      this.shareInfo = {};
      this.crumbs = [];
      this.pageSize = 100;
      this.currPage = 1;

      const needInitBoolean = ['loading', 'hasMore'];
      needInitBoolean.forEach(key => {
        this[key] = false;
      });
      this.hasAuthority = true;

      const needInitString = [
        'extract',
        'Bucket',
        'Region',
        'Prefix',
        'marker',
      ];
      needInitString.forEach(key => {
        this[key] = '';
      });

      // 初始化所有弹窗展示
      Object.keys(this.dialogShow).forEach(key => {
        this.dialogShow[key] = false;
      });
      this.resetSearch();
    },
    // 分页器改变
    changePage(page) {
      if (page.pageSize > this.pageSize || page.currPage > this.currPage) {
        if (this.hasMore) {
          this.listObjects();
        }
      }
      this.currPage = page.currPage;
      this.pageSize = page.pageSize;
    },
    // 判断当前链接是否超时
    isExpiredNow() {
      const { expire } = this.shareInfo;
      const now = Date.now() / 1000;
      const isExpired = expire < now;
      if (isExpired) {
        storage.flush('cookie');
        this.restData();
      }
      this.isExpired = isExpired;
      return isExpired;
    },
    handleUrlParams() {
      tips.loading(this.$t('core.loading'));
      const urlRes = utils.queryStringParse(window.location.search.substr(1));
      this.id = urlRes.id;
      this.sKeyToken = urlRes.token;

      // 1. 检查链接是否过期
      dao
        .checkShareUrl({ id: this.id })
        .then(() => {
          if ('nopassword' in urlRes) {
            this.extract = '';
            this.getShareConfig();
            return;
          }
          // 2. 检查本地是否已有 token
          const accessCode = storage.get(StoreKey.ACCESSCODE);
          const shareInfoToken = storage.get(StoreKey.TOKEN);
          const id = storage.get(StoreKey.ID);
          if (accessCode && shareInfoToken && id === this.id) {
            this.handleShareConfig(shareInfoToken, accessCode);
          } else {
            this.showIndex();
            this.showExtract = true;
          }
        })
        .catch(err => {
          this.showIndex();
          this.tableShowErr = err;
          console.log('handleUrlParams -> err', err);
          this.showExtract = false;
        });
    },
    // 拉取远端文件/文件夹分享信息
    async getShareConfig() {
      try {
        const res = await dao.getSharedConfig({
          id: this.id,
          extract: this.extract,
        });
        this.showExtract = false;
        const { accessCode, token: shareInfoToken } = res;
        storage.add(StoreKey.ID, this.id);
        storage.add(StoreKey.TOKEN, shareInfoToken);
        storage.add(StoreKey.ACCESSCODE, accessCode);
        storage.add(StoreKey.EXTRACT, this.extract);
        this.handleShareConfig(shareInfoToken, accessCode);
      } catch (err) {
        console.log('wonder_log ~ getShareConfig ~ err', err);
        // error
        this.showIndex();
        this.extractErrorCode = err.code;
      }
    },
    // 处理解析远端文件/文件夹分享信息
    async handleShareConfig(token, accessCode) {
      this.loading = true;
      const shareInfo = await utils.AESDecrypt(token, accessCode);
      const skey = await utils.AESDecrypt(this.sKeyToken, accessCode);
      if (!shareInfo || !skey) {
        this.showIndex();
        this.showExtract = true;
        this.extractErrorCode = 'ErrorExtractCode';
        return;
      }

      this.shareInfo = {
        skey,
        ...utils.queryStringParse(shareInfo),
      };

      this.showExtract = false;
      // 超时
      if (this.isExpiredNow()) return;

      // 自定义请求域名
      const { domain } = this.shareInfo;
      if (domain && /^[a-z0-9.-]+$/.test(domain)) {
        cos.options.Domain = domain;
      } else {
        cos.options.Domain = '';
      }

      this.$store.expiredTime = this.shareInfo.expire;

      this.shareInfo.files = JSON.parse(
        utils.decodeBase64(this.shareInfo.files.replace(/\s+/g, '+')),
      );
      this.shareInfo.action = JSON.parse(
        utils.decodeBase64(this.shareInfo.action),
      );

      setCredentials(this.shareInfo);
      this.Bucket = this.shareInfo.Bucket;
      this.Region = this.shareInfo.Region;
      this.Prefix = this.shareInfo.Prefix;
      this.isMaz = this.shareInfo.isMaz === '1' || this.shareInfo.isMaz === 'true';
      this.initCrumbs();
      eventProxy.emit('show-openClient');
      this.showIndex();
    },
    // 初始化第一次加载时的列表
    initList() {
      const list = this.shareInfo.files.map(item => {
        const name = this.shareInfo.version ? item.name : decodeURIComponent(item.name);
        const key = this.Prefix + name;
        if (Object.keys(item).length > 1) {
          item.Key = key;
          item.LastModified = item.mtime;
          item.Size = item.size;
          item.isDir = false;
        } else {
          item.Prefix = `${key}/`;
          item.isDir = true;
        }
        return this.formatFileItem(item);
      });
      if (list.length === 1) {
        this.openFolderOrFile(list[0]);
      } else {
        this.list = list;
      }
      // this.dragSelection = new DragSelection(
      //   this.fileBody,
      //   this.$store.layout,
      //   this.list,
      // );
    },
    // 拉取 cos 对象列表数据
    async listObjects() {
      if (this.isExpiredNow()) return;

      if (!this.marker) {
        this.list = [];
      }
      const { Bucket, Region } = this;
      this.loading = true;
      // 若为前缀搜索且关键字不为空，则修改搜索状态
      if (this.keyword) {
        this.isSearching = true;
      }

      try {
        const data = await cos.getBucket(
          {
            Bucket,
            Region,
            Prefix: this.Prefix + (this.keyword || ''),
            Delimiter: '/',
            Marker: this.marker,
          },
        );

        this.loading = false;
        this.hasMore = data.IsTruncated === 'true';
        this.marker = data.NextMarker;
        this.handleFileList(data);
        // 若为前缀搜索且关键字不为空，则修改搜索状态
        if (this.keyword) {
          this.isSearching = false;
          this.isSearched = true;
          this.isSearchDone = true;
        }
      } catch (err) {
        console.log('wonder_log ~ listObjects ~ err', err);
        this.loading = false;

        const { code, message } = err;
        if (code === 'AccessDenied') {
          this.hasAuthority = false;
        } else if (code === -1) {
          tips.error(message);
        } else {
          tips.error(err.code);
        }
        if (this.keyword) {
          this.isSearching = false;
        }
      }
    },
    handleFileList(data) {
      this.hasMore = data.IsTruncated === 'true';
      this.marker = data.NextMarker;
      const list = [];
      if (data.CommonPrefixes && data.CommonPrefixes.length > 0) {
        const CommonPrefixes = data.CommonPrefixes.filter(
          v => v.Prefix !== this.Prefix,
        ); // 过滤出目录
        list.push(...CommonPrefixes.map(this.formatFileItem));
      }
      if (data.Contents && data.Contents.length > 0) {
        const Contents = data.Contents.filter(v => !v.Key.endsWith('/')); // 过滤出文件
        list.push(...Contents.map(this.formatFileItem));
      }
      if (this.keyword) {
        this.list = list;
        this.arrangeList();
      } else {
        this.pushList(list);
      }
    },
    // 增加文件/文件夹
    pushList(list) {
      let i = list.length;
      let item = {};
      let index = 0;
      let relKey = '';
      let dirKey = '';
      const deepMap = {};
      const deepItems = [];
      while (--i >= 0) {
        item = list[i];
        if (item.key.indexOf(this.Prefix) === 0) {
          relKey = item.key.substr(this.Prefix.length);
          if (item.isDir) {
            relKey = relKey.slice(0, -1);
          }
          index = relKey.indexOf('/');
          if (index > -1) {
            dirKey = `${this.Prefix + relKey.substr(0, index)}/`;
            if (!deepMap[dirKey]) {
              deepItems.push(this.formatFileItem({ Prefix: dirKey }));
              deepMap[dirKey] = true;
            }
            list.splice(i, 1);
          }
        } else {
          list.splice(i, 1);
        }
      }
      list.push(...deepItems);
      this.list.push(...list);
      this.arrangeList();
    },
    // 整理列表，去重，排序
    arrangeList() {
      // 从后往前去重
      let i = this.list.length;
      const hasNodeId = {};
      while (--i >= 0) {
        if (hasNodeId[this.list[i].key]) {
          this.list.splice(i, 1);
        }
        hasNodeId[this.list[i].key] = true;
      }
      // 排序
      this.list = this.list.sort((a, b) => {
        let com = 0;
        if (a.isDir !== b.isDir) {
          com = a.isDir ? -1 : 1;
        } else {
          com = a.name > b.name ? 1 : -1;
        }
        return com;
      });
      this.$refs.table.renderClientHeight();
    },
    // 整理列表格式
    formatFileItem(item) {
      let o;
      if (item.Prefix) {
        let name = item.Prefix.slice(0, -1);
        name = name.substr(name.lastIndexOf('/') + 1);
        o = {
          key: item.Prefix || item.name,
          name,
          isDir: true,
          size: '-',
          mtime: '-',
          StorageClass: '',
        };
      } else {
        o = {
          key: item.Key,
          name: item.Key.substr(item.Key.lastIndexOf('/') + 1),
          isDir: false,
          size: parseInt(item.Size, 10),
          mtime: dateToUnix(item.LastModified),
          StorageClass: item.StorageClass,
        };
      }
      return o;
    },
    // 上传完成
    onUploadFinish(r) {
      if (!r.err) {
        const info = r.data;
        if (info.Bucket === this.Bucket && info.Region === this.Region) {
          const {
            Key, ETag, size, StorageClass, LastModified,
          } = info;
          const item = this.formatFileItem({
            Key,
            ETag,
            Size: size,
            StorageClass,
            LastModified,
          });
          this.pushList([item]);
        }
      }
    },
    // 表格/网格点击操作
    onEventAction({ action, item }) {
      if (this.isExpiredNow()) return;

      switch (action) {
        case 'download':
          this.onDownload(item);
          break;
        case 'openFolderOrFile':
          this.openFolderOrFile(item);
          break;
        case 'delete':
          this.onDeleteFiles(item);
          break;
        case 'uploadFiles':
          this.dialogShow.advanceUpload = true;
          break;
        case 'createFolder':
          this.dialogShow.create = true;
          break;
        default:
          break;
      }
    },
    // 打开文件夹 / 文件
    openFolderOrFile(item) {
      if (item.isDir) {
        this.openFolder(item);
        this.resetSearch();
      } else {
        // this.openFileDetail(item);
      }
    },
    // 打开文件夹
    openFolder(item) {
      this.crumbs.push({ name: item.name, prefix: item.key });
      this.Prefix = item.key;
    },
    onDownload(item) {
      cos.getObjectUrl(
        {
          Bucket: this.Bucket,
          Region: this.Region,
          Key: item.key,
          Sign: true,
          Expires: 3600,
          Query: {
            'response-content-type': 'application/octet-stream',
            'response-content-disposition': 'attachment',
          },
        },
        (err, data) => {
          if (err) {
            tips.error(err);
            return;
          }
          let { Url } = data;

          // 修复 q-policy 参数编码问题
          if (Url.includes('q-policy')) {
            try {
              // 更精确的匹配和替换 q-policy 参数
              const policyMatch = Url.match(/q-policy=([^&]*)/);
              if (policyMatch && policyMatch[1]) {
                const originalPolicy = policyMatch[1];
                // 确保 policy 参数被正确编码
                const encodedPolicy = encodeURIComponent(decodeURIComponent(originalPolicy));
                Url = Url.replace(`q-policy=${originalPolicy}`, `q-policy=${encodedPolicy}`);
              }
            } catch (encodingError) {
              console.warn('Failed to fix policy encoding:', encodingError);
            }
          }
          downloadUrl(Url);
        },
      );
    },
    onDeleteFiles(item) {
      if (item) {
        this.selectedList = [item];
      }
      this.dialogShow.delete = true;
    },
    // 删除文件夹内最后一个文件或者文件夹后，重新创建该文件夹
    fixFolder(path) {
      // 如果是最后一个文件（夹）
      if (!this.list.length && path !== '' && !this.hasMore) {
        // 创建当前文件夹
        // this.$refs.createFolder.createFolder(true);
      }
    },
    onSearch() {
      if (this.crumbs.length === 1) {
        tips.error(this.$t('cos.root_directory_prefix_search_not_allowed'));
      } else {
        this.resetFolder();
      }
    },
    // 关闭搜索：直接清除刷新
    closeSearch() {
      this.resetSearch();
      this.resetFolder();
    },
    // 取消搜索：保留已搜索到的列表，仅停止搜索
    cancelSearch() {
      this.isSearchDone = true;
      this.isSearching = false;
    },
    // 刷新界面
    onRefresh() {
      this.resetSearch();
      this.resetFolder();
    },
    // 重置搜索状态
    resetSearch() {
      // 清空搜索状态
      this.isSearching = false;
      this.isSearched = false;
      this.isSearchDone = false;
      this.keyword = '';
    },
    // 清空且重置
    resetFolder() {
      if (this.isExpiredNow()) return;

      // 清空搜索状态
      this.isSearching = false;
      this.isSearched = false;
      this.isSearchDone = false;

      // 重置列表数据
      this.list = [];
      this.marker = '';
      this.hasMore = false;
      this.currPage = 1;

      this.listObjects();
    },
    // // 获取当前页渲染的 list
    // getCurrRenderList() {
    //   // 筛选出总列表
    //   const totalList = this.list;
    //   // 计算总大小和当前页码
    //   const totalNum = totalList.length;
    //   // 找出当前显示的列表
    //   const start = (this.currPage - 1) * this.pageSize;
    //   const end = Math.min(totalNum, start + this.pageSize);
    //   const pageList = totalList.slice(start, end);
    //   return pageList || [];
    // },
    // // 拖拽选区开始
    // selectorStart(data) {
    //   if (this.dragSelection) {
    //     const { fileBody } = this;
    //     // console.log('selectorStart -> fileBody', fileBody);
    //     const { layout } = this.$store;
    //     const currRenderList = this.getCurrRenderList();
    //     this.dragSelection.refresh(fileBody, layout, currRenderList);
    //     this.dragSelection.selectorStart(data);
    //     this.selectedList = this.dragSelection.selectedList;
    //   }
    // },
    // // 拖拽选区移动
    // isSameList(l1, l2) {
    //   return l1.map(v => v.key).join(',') === l2.map(v => v.key).join(',');
    // },
    // // 拖拽选区移动
    // selectorMove(data) {
    //   if (this.dragSelection) {
    //     this.dragSelection.selectorMove(data);
    //     if (
    //       !this.isSameList(this.dragSelection.selectedList, this.selectedList)
    //     ) {
    //       this.selectedList = this.dragSelection.selectedList;
    //     }
    //   }
    // },
    // // 拖拽选区结束
    // selectorEnd(data) {
    //   if (this.dragSelection) {
    //     this.dragSelection.selectorEnd(data);
    //     this.selectedList = this.dragSelection.selectedList;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
$xs: 360px;
$sm: 600px;
.list-body-container {
  .justify-grid {
    ::v-deep .tc-15-btn {
      @media screen and (max-width: $sm) {
        padding: 0 7px;
      }
    }
    ::v-deep .refresh {
      margin: 0 20px;
      @media screen and (max-width: $sm) {
        margin: 0;
      }
    }
    ::v-deep .tc-15-search,
    .tc-15-search-words {
      @media screen and (max-width: $xs) {
        width: 130px;
      }
    }
  }
}

.extract-style {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .list--body-extract {
    margin-top: -200px;
    padding: 60px 60px 50px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 0 10px rgba(171, 198, 235, 0.3);
    .form-list {
      .form-label,
      .form-input {
        padding-bottom: 0;
      }
    }
  }
}
.expire-time-tips {
  display: flex;
}
.search-bar.tc-action-grid {
  padding: 0;
  background-color: #d6e8ff;
  .justify-grid {
    height: 28px;
    .col {
      font-size: 12px;
      color: #08090a;
      .search-text {
        margin-left: 20px;
      }
      .cancel-search {
        margin-right: 20px;
      }
    }
  }
}
</style>
